import { useState } from "react";
import { X, Loader2, Flag } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

const REASONS = [
    { id: "fake_property",     label: "Fake Property" },
    { id: "incorrect_info",    label: "Incorrect Information" },
    { id: "spam",              label: "Spam" },
    { id: "inappropriate",     label: "Inappropriate Content" },
    { id: "fraud",             label: "Fraud / Suspicious" },
    { id: "copyright",         label: "Copyright Issue" },
    { id: "other",             label: "Other" },
];

export default function ReportReelSheet({ reel, onClose }) {
    const [reason, setReason]   = useState("");
    const [comment, setComment] = useState("");
    const [busy, setBusy]       = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!reason) { toast.error("Please pick a reason"); return; }
        setBusy(true);
        try {
            await api.post(`/reels/${reel.id}/report`, { reason, comment: comment || null });
            toast.success("Reported — our team will review this reel.");
            onClose();
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || "Could not report reel");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="fixed inset-0 z-40 flex items-end" style={{ background: "rgba(0,0,0,0.65)" }}
             onClick={onClose} data-testid="reel-report-sheet">
            <form onSubmit={submit} className="w-full bg-white rounded-t-2xl p-4 max-h-[80vh] overflow-y-auto"
                  onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-3">
                    <div className="font-heading font-extrabold text-[14px] flex items-center gap-1" style={{ color: "#002657" }}>
                        <Flag className="w-3.5 h-3.5" /> Report this Reel
                    </div>
                    <button type="button" onClick={onClose} className="w-8 h-8 rounded-full flex items-center justify-center"
                            style={{ background: "#f4f4f5" }} data-testid="reel-report-close">
                        <X className="w-4 h-4" />
                    </button>
                </div>
                <div className="grid grid-cols-2 gap-2">
                    {REASONS.map((r) => (
                        <button
                            type="button"
                            key={r.id}
                            onClick={() => setReason(r.id)}
                            data-testid={`reel-report-reason-${r.id}`}
                            className="px-3 py-2 rounded-lg border text-[12px] font-bold text-left"
                            style={{
                                background: reason === r.id ? "#FBF6E0" : "white",
                                borderColor: reason === r.id ? "#DAA520" : "rgba(0,38,87,0.12)",
                                color: reason === r.id ? "#8B6712" : "#002657",
                            }}
                        >
                            {r.label}
                        </button>
                    ))}
                </div>
                <textarea rows={3} value={comment} onChange={(e) => setComment(e.target.value)}
                    placeholder="Additional details (optional)"
                    data-testid="reel-report-comment"
                    className="mt-3 w-full px-3 py-2 rounded-lg border text-[12.5px]"
                    style={{ borderColor: "rgba(0,38,87,0.15)" }} />
                <button
                    type="submit" disabled={busy}
                    data-testid="reel-report-submit"
                    className="mt-3 w-full py-3 rounded-xl text-[13px] font-extrabold flex items-center justify-center gap-1 text-white"
                    style={{ background: "linear-gradient(90deg, #DC2626, #B91C1C)" }}
                >
                    {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Flag className="w-3.5 h-3.5" />}
                    Submit Report
                </button>
            </form>
        </div>
    );
}
